module.exports = __webpack_public_path__ + "img/hongbao.7fef81bf.png";